module.exports = __webpack_public_path__ + "static/media/Github_Badge.c543e0f9.png";